import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        const stored = localStorage.getItem('language');
        return stored || 'en';
    });

    const switchLanguage = (lang) => {
        const newLang = lang.toLowerCase();
        i18n.changeLanguage(newLang);
        setCurrentLanguage(newLang);
        localStorage.setItem('language', newLang);

        // Update URL with language prefix
        const pathWithoutLang = location.pathname.replace(/^\/(es|pt)/, '');
        if (newLang === 'en') {
            navigate(pathWithoutLang);
        } else {
            navigate(`/${newLang}${pathWithoutLang}`);
        }
    };

    useEffect(() => {
        // Initial language setup
        const pathLang = location.pathname.match(/^\/(es|pt)/)?.[1];
        if (pathLang && pathLang !== currentLanguage) {
            switchLanguage(pathLang);
        } else if (!pathLang && currentLanguage !== 'en') {
            switchLanguage('en');
        }
    }, []);

    return (
        <LanguageContext.Provider value={{ currentLanguage, switchLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}
